/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import { Collapse as BCollapse } from 'reactstrap';

import '../../styles/collapse.scss';

export default function Collapse({ id, isToggled, setTogglequestion, title, content }) {
  return (
    <div className={`${isToggled ? 'active' : ''} collapse-wrapper`}>
      <div className="accordion-header" role="presentation" onClick={() => setTogglequestion(id)}>
        <h4>{title}</h4>
      </div>
      <BCollapse isOpen={isToggled}>
        <div className="accordion-body" dangerouslySetInnerHTML={{ __html: content }} />
      </BCollapse>
    </div>
  );
}

Collapse.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  id: PropTypes.string,
  isToggled: PropTypes.bool,
  setTogglequestion: PropTypes.func
};

Collapse.defaultProps = {
  title: '',
  content: '',
  id: '',
  isToggled: false,
  setTogglequestion: () => {}
};
